<template>
  <inner-page-wrapp>
    <div class="page-container">
      <router-view />
    </div>
  </inner-page-wrapp>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import axios from "axios";

import InnerPageWrapp from "../../../components/InnerPageWrapp";
import { nprogressMixin } from "../../../mixins";

export default {
  name: "Problems",
  components: { InnerPageWrapp },
  mixins: [nprogressMixin],
  computed: {
    ...mapState(["problemTypes", "problemObjectTypes"])
  },
  mounted() {
    if (this.problemTypes.length === 0) {
      axios.cancel("problem-types");

      this.getProblemTypes();
    }

    if (this.problemObjectTypes.length === 0) {
      axios.cancel("problem-object-types");

      this.getProblemObjectTypes();
    }
  },
  beforeDestroy() {
    axios.cancel("problem-types");
    axios.cancel("problem-object-types");

    this.setProblemTypes([]);
    this.setProblemObjectTypes([]);
  },
  methods: {
    ...mapActions(["getProblemTypes", "getProblemObjectTypes"]),
    ...mapMutations(["setProblemTypes", "setProblemObjectTypes"])
  }
};
</script>
